
import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogDescription,
} from "@/components/ui/dialog";
import { SidebarItem } from "./sidebar-item";
import { FileText } from "lucide-react";

interface AboutKlaraDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const AboutKlaraDialog: React.FC<AboutKlaraDialogProps> = ({
  open,
  onOpenChange,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogTrigger asChild>
        <SidebarItem
          href="#"
          icon={<FileText className="h-5 w-5" />}
          title="Om Klara.ai"
          isActive={false}
          onClick={() => onOpenChange(true)}
        />
      </DialogTrigger>
      <DialogContent className="max-w-3xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Beskrivelse av Klara – et KI-verktøy for datadrevet arbeidsgiveroppfølging</DialogTitle>
          <DialogDescription>
            Les mer om hva Klara er og hvordan verktøyet kan hjelpe deg.
          </DialogDescription>
        </DialogHeader>
        <div className="prose prose-sm mt-4">
          <section className="space-y-4">
            <p>
              Klara er et kunstig intelligens-verktøy utviklet for å støtte jobbveiledere i Arbeid & Inkluderings medlemsbedrifter med datadrevet beslutningsstøtte. Verktøyet hjelper veiledere med å analysere arbeidsmarkedstrender, identifisere kompetansebehov og koble arbeidsgivere med aktuelle inkluderingsbedrifter og kandidater.
            </p>

            <div>
              <h3 className="font-bold text-lg">Bruksscenarier for Klara</h3>
              <p>Klara bistår jobbveiledere med følgende:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Innsikt i hvilke bransjer som har høy eller lav etterspørsel etter arbeidskraft akkurat nå</li>
                <li>Innsikt i hvilke bransjer som sannsynligvis vil ha høy eller lav etterspørsel etter arbeidskraft i årene fremover</li>
                <li>Anbefaling av utdanninger og arbeidspraksis praksis</li>
                <li>Anbefaling av relevante utdanningsløps gjennom integrasjon med Utdanning.no</li>
                <li>Finne aktuelle bedrifter for arbeidspraksis gjennom integrasjon med Enhetsregisteret</li>
                <li>Finne ledige stillinger og andre typer ansettelsesmuligheter via integrasjon med Arbeidsplassen.no</li>
                <li>Hjelper veiledere med å utforme forslag til tilrettelegging og jobbdesign</li>
                <li>Sikre at henvendelser til arbeidsgivere er i tråd med Tiltaksforskriften og annet relevante reglement</li>
              </ul>
            </div>

            <div>
              <h3 className="font-bold text-lg">Begrensninger og ansvar</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>Bruker av Klara skal forholde seg til de til enhver tid gjeldende retningslinjer og står selv ansvarlig for at disse overholdes</li>
                <li>Klara behandler ikke personopplysninger</li>
                <li>Verktøyet skal brukes av jobbveiledere og arbeidsgivere, ikke arbeidssøkere direkte</li>
                <li>Bruk av Klara skal være et supplement til relasjonsbasert veiledning og tilrettelegging</li>
              </ul>
            </div>
          </section>
        </div>
      </DialogContent>
    </Dialog>
  );
};
